<i18n
  src="@/locales/views/packing_house/quality_control/query_container/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_containers')"
    :params="{
      packing_house_id: packing_house_id,
      packing_house_process_id: packing_house_process_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      packing_house_process.name,
      container?.container_code
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info :container="container"></container-info>

    <h1 class="page-title mt-8">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-slate-200">
          <li
            v-for="template in packing_process_quality_template"
            :key="template.id"
          >
            <div
              class="block hover:bg-slate-50 cursor-pointer"
              @click="goToListQualityInspects(template)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ template.quality_template.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </a>
                  </div>
                </div>

                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p class="flex items-center text-sm text-gray-500">
                      <i
                        class="fa-solid fa-crate-apple flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.number_exported_batches_with_inspects }} /
                      {{ template.number_exported_batches }}
                    </p>
                    <p
                      class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                    >
                      <i
                        class="fa-solid fa-box-check flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.number_inspects }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/quality_control/query_container/list_templates.js";
import ContainerInfo from "@/components/views/packing_house/quality_control/query_container/ContainerInfo.vue";

export default {
  components: { ContainerInfo },
  name: "PhQualityControlQueryContainerListTemplates",

  props: ["packing_house_id", "packing_house_process_id", "container_id"],
  data() {
    return {
      load_data_general: false,
      packing_house_process: {},
      container: {},
      packing_process_quality_template: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchPackingHouseProcess();
      await this.fetchContainer();
      await this.fetchTemplates();
      this.load_data_general = true;
    },
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.packing_house_id,
        this.packing_house_process_id,
        this.container_id
      );
      this.container = response.data;
    },
    fetchTemplates: async function () {
      let response = await Requester.fetchTemplates(
        this.packing_house_id,
        this.packing_house_process_id,
        this.container_id
      );
      this.packing_process_quality_template = response.data;
    },
    goToListQualityInspects: function (template) {
      this.$router.push({
        name: this.routeName("list_quality_inspects"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          container_id: this.container_id,
          quality_template_id: template.quality_template_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
